<template>

  <div class="avatar-wrapper"
       :class="computedClasses"
        :style="computedStyles"
  >

    <img v-if="imagePath"
         class="avatar-image"
         :src="imagePath"/>

    <div v-else-if="!imagePath && name || text"
         class="avatar-initials">
      {{text || initials}}
    </div>
    <slot></slot>
  </div>

</template>

<script>
  export default {
    name: "AvatarImage",
    props: {
      imagePath: {
        type: String
      },
      name: {
        type: String
      },
      text: {
        type: String
      },
      colorId: {
        type: Number
      },
      size: {
        type: String,
        default: 'md'
      },
      customSize: {
        type: String,
        default: ''
      },
    },
    computed: {
      computedClasses() {
        let res = this.colorClass
        if( !this.customSize ) {
          res += " " + this.size
        }
        return res
      },
      colorClass() {
        return !this.imagePath && this.colorId ? `has-color color-${this.colorId}` : '';
      },
      initials() {
        return this.getInitials(this.name);
      },
      computedStyles() {
        if(!this.customSize) {
          return {}
        }
        return {
          height: this.customSize,
          width: this.customSize,
          minWidth: this.customSize,
        }
      }
    },
    methods: {
      getInitials(name) {
        let split = name.trim().split(' ').filter(Boolean);
        let initials = '';

        if (split.length) {
          initials += split[0][0];

          if (split[1]) {
            initials += split[1][0];
          } else if (split[0][1]) {
            initials += split[0][1];
          }
        }

        return initials.toUpperCase();
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "@/assets/scss/abstract/_variables.scss";

  .avatar-wrapper {

    border-radius: 50%;
    background-color: $grey-color-5;
    text-align: center;
    border: 1px solid $white-color-1;

    &.has-color {
      background-color: var(--color-dark);
    }

    &.x-sm {
      height: 25px;
      width: 25px;
      font-size: 11px;
    }

    &.sm {
      height: 35px;
      width: 35px;
    }

    &.md {
      height: 50px;
      width: 50px;
    }


    .avatar-image {
      display: block;
      margin: auto;
      height: 100%;
      width: 100%;
      object-fit: cover;
      border-radius: 50%;
    }

    .avatar-initials {
      color: $white-color-1;
      position: relative;
      top: 50%;
      font-family: var(--primary-font-family);
      transform: translateY(-50%);
    }
  }

  .border--light-gray {
    border: 1px solid rgba($black-color-1, .3);
    background-color: $white-color-1;

    .avatar-initials {
      color: rgba($black-color-1, .3);
    }
  }

</style>
